import React from 'react';
import { useIntl } from 'react-intl';
import CurrencyList from '../../../components/SiteAdmin/Currency/CurrencyList';
import Loader from '../../../components/Common/Loader/Loader';
import getCurrency from './currencyList.graphql';
import messages from '../../../locale/messages';

import useQueryResponse from '../../../lib/hooks/useQueryResponse';



const Currency = () => {

    const intl = useIntl()
    const { data: CurrencyData, loading, refetch } = useQueryResponse({
        query: getCurrency,
        variables: {
            currentPage: 1,
            searchList: ''
        },
        fetchPolicy: 'network-only',
        ssr: false
    })

    return (
        <Loader type={"page"} show={loading}>
            <h1 className='siteAdminPrimaryHeading'>{intl.formatMessage(messages.currencyList)}</h1>
            {!loading && <CurrencyList CurrencyData={CurrencyData} refetch={refetch} loading={loading} />}
        </Loader>
    );
}

export default Currency